import styled from "styled-components";
import themes from "@/styles/themes";
import {mdiAlert} from "@mdi/js";
import Icon from "@mdi/react";
import { SET_USER_STEP} from "@/store/slices/appSlice";
import {useCookies} from 'react-cookie';
import {useDispatch, useSelector} from "react-redux";
import InputTelefone from "@/components/inputs/inputTelefone";
import Button from "@/components/inputs/button";
import {GET_USER, IUserValue, SET_USER} from "@/store/slices/userSlice";
import Events from "@/utils/Events";
import { SET_LEAD_CELULAR } from "@/store/slices/leadSlice";
import Apm from "@/utils/Apm";
import { setTelefone } from "@/api/assine";
import {useEffect, useMemo, useState} from "react";
import { isTelephoneNumber } from "@/utils/validation";
import Nullable from "@/types/utils/Nullable";
import {GET_OFFER_TYPE} from "@/store/slices/offerSlice";


const Block = styled.div`
  background: white;
  padding: 34px 38px;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0 7px 40px 0 rgba(0, 0, 0, 0.06);
  border: solid 1px #d6d6d6;
  position: relative;
`
const ContentArea = styled.div`
  position: relative;
  width: 300px;
  max-width:100%;
  margin: 0 auto;
`
const IconDiv = styled.div`
  background: ${themes.yellow};
  color: ${themes.white};
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  margin: 6px 0;
`

const SubTitle = styled.div`
  font-size: 16px;
  margin: 6px 0;
`

const TitleText = styled.h1`
  font-size: 16px;
  margin: 6px 0;
  color: ${themes.estadao};
  line-height: 24px;
  font-weight: 600;
`

interface IAtualizarTelefoneProps {
  actionAfter?: () => void
}

export default function AtualizarTelefone(props: IAtualizarTelefoneProps) {
    const dispatch = useDispatch();
    const [cookies, setCookie] = useCookies(['OESP_INFO','PORTAL_AUTH']);
    const events = useMemo((): Events => {
        return new Events();
    }, []);
    const initialValues: IUserValue = useSelector(GET_USER)
    const [celular, setCelular] = useState('')
    const [errorMessage, setErrorMessage] = useState<Nullable<string>>(null)
    const offer_type = useSelector(GET_OFFER_TYPE)

    const dia = 24 * 60 * 60 * 1000;
    const numeroDeDias = 7 * dia;
    const dataAtual = new Date();
    dataAtual.setMilliseconds(dataAtual.getMilliseconds() + numeroDeDias)

    function normalizeTelefone(telefone:string): string[] {
      const telefoneNorm = telefone.replace(/\D/g, '');
      const ddd = telefoneNorm.slice(0, 2)
      const numero = telefoneNorm.slice(2)
      return [ddd, numero]
    }
    
    async function updateTelefone(telefone: string) {

      const telefoneNorm = normalizeTelefone(telefone)
      try {
        await setTelefone({
          ddd: telefoneNorm[0],
          telefone: telefoneNorm[1],
          cookie: `PORTAL_AUTH=${cookies.PORTAL_AUTH}`
        }).then(() => {
          props.actionAfter && props.actionAfter()
          return true  
        }).catch(() =>{
            return false
        });
        return true
      } catch (error) {
          Apm.captureError(`UPDATE_TELEFONE_NORMALIZE: ${error}`)
        return false
      }
    }

    async function handleSubmit(event: any) {
        event.preventDefault()
        events.trigger("cadastro_celular_continuar", {offer_type})

        if (!isTelephoneNumber(celular)) {
            setErrorMessage('Celular inválido')
            events.trigger("cadastro_erro_celular", { offer_type })
            return
        }

        setErrorMessage(null)

        dispatch(SET_USER({
            ...initialValues,
            telefone: celular
        }));
        let valueCookies = cookies.OESP_INFO;
        valueCookies.telefone = celular;
        setCookie('OESP_INFO', valueCookies, {
            domain: '.estadao.com.br',
            expires: dataAtual,
            secure: true,
            path: '/'
        })
        await updateTelefone(celular);
        dispatch(SET_LEAD_CELULAR(celular))
        dispatch(SET_USER_STEP(2))
    }

    useEffect(() => {
        events.trigger("cadastro_celular", { offer_type })
    }, [events, offer_type]);

    return (
        <Block>
            <ContentArea>
                <IconDiv>
                    <Icon path={mdiAlert} size={1}/>
                </IconDiv>

                <TitleText>Não Localizamos seu celular</TitleText>

                <SubTitle>
                    Precisamos atualizar seu cadastro <br/>
                    para seguir com a assinatura.<br/>
                    <span style={{fontWeight: 'bold'}}>Por favor, preencha no campo abaixo: </span> <br/>
                </SubTitle>

                <form onSubmit={handleSubmit}>
                  <InputTelefone
                    id="telefone"
                    name="telefone"
                    type="text"
                    placeholder="(11) 99999-9999"
                    onClick={() => {
                      events.trigger("cadastro_celular_atualizar", { offer_type })
                    }}
                    onChange={setCelular}
                    errorMessage={errorMessage}
                  />
                  <Button type="submit">Continuar</Button>
                </form>
            </ContentArea>
        </Block>
    )
}
